module.exports = __webpack_public_path__ + "img/ios-head-bg.5bca70ab.png";